import React, { useContext, useEffect, useState } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { AppContext } from '../../../contexts/AppContext';
import { toast } from 'react-toastify';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { SectorDataForm } from '../../../app/models/Sector';
import useSectorService from '../../../app/services/hooks/useSectorService';
import SectorFormContainer from './SectorFormContainer';
import SectorForm from './forms/SectorForm';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import { SectorBusinessRulesEnum } from '../../../app/shared/enums';

interface Props {
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const SectorCreate = ({ onSaved, onCancel, onError }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);

    const [errorGetData, setErrorGetData] = useState('');
    const [sector, setSector] = useState<SectorDataForm>({ name: '' });
    const [sectorBusinessRulesEnum, setSectorBusinessRulesEnum] = useState<SectorBusinessRulesEnum[]>([]);
    

    const [errorFields, setErrorFields] = useState<any>();

    const { fetchingStoreSector, fetchingCreateSector, storeSector, createSector } = useSectorService();

    useEffect(() => {
        if (showLoading) showLoading('loading', 'Cargando datos...');

        createSector({
            onSuccess: (response: ServiceResponse) => {

                setSectorBusinessRulesEnum(response.data.sector_business_rules_enum);

                if (hideLoading) hideLoading();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                if (onError) onError();
            }
        });
    }, []);


    const store = () => {
        if (showLoading) showLoading('loading', 'Guardando sector...');
        storeSector(sector, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                toast.success(response.message, {
                    autoClose: 2500
                });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();

                setErrorFields(errorFields.data);
            }
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    if (errorGetData !== '') {
        return <div>{errorGetData}</div>;
    }

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <SectorForm
                        sectorDataForm={sector}
                        setSectorDataForm={setSector}
                        errorFields={errorFields}
                        sectorBusinessRulesEnum={sectorBusinessRulesEnum}
                    />
                </div>
            </div>
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={cancel} locked={fetchingStoreSector} />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={store} locked={fetchingStoreSector} />
                </div>
            </div>
        </>
    );
};

export default SectorCreate;
